const appInfo = {
    title: 'Superfinals'
};
export default appInfo;

